/**
 * Post-Pipeline Hook
 *
 * Standard extensibility point that runs LAST in every pipeline.
 * Currently a pass-through, but can be subclassed or configured for:
 * - Cross-cutting concerns (logging, cleanup, metrics)
 * - Post-processing after all other hooks
 * - Pipeline finalization logic
 *
 * Always has priority 999 (runs after all other hooks).
 */

import { BaseHook } from './base/BaseHook';
import type { IPipelineContext, HookResult } from '../types';

export class PostPipelineHook extends BaseHook {
  readonly name = 'PostPipelineHook';
  readonly priority = 999; // Always last

  async execute(_context: IPipelineContext): Promise<HookResult> {
    // Pass-through by default. Override in subclass for custom logic.
    return this.continue();
  }
}
